<template>
    <div class="pantalla-menu">
        <div class="container-mob w-100">
            <div class="d-flex align-center justify-content-between">
                <h2>Perfil</h2>
                <!--<router-link :to="{ name: 'editar-perfil' }">
                    <img src="/assets/img/settings.png" alt="" width="30px">
                </router-link>-->
            </div>
            <div class="pantalla-perfil mt-5">
                <div class="text-center">
                    <router-link :to="{ name: 'editar-perfil' }" class="color-red">
                        <div class="empresa-perfil d-flex justify-content-center align-items-center position-relative">
                            <div class="logo-empresa" :style="empresaImage"></div>
                            <i class="fas fa-pencil-alt position-absolute" style="bottom: 0; right: -15px;"></i>
                        </div>
                    </router-link>
                    <h2 class="mt-3">{{ this.user.empresa }}</h2>
                    <p class="color-red">{{ full_name }}</p>

                </div>
            </div>
            <div class="enlace-perfil">
                <a href="/presupuestos" class="">
                    <div class=" d-flex justify-content-between">
                        <div>
                            <i class="fas fa-download"></i>
                            <span class="ms-3">Presupuestos</span>
                        </div>
                        <i class="fas fa-chevron-right"></i>
                    </div>
                </a>
            </div>
            <div class="enlace-perfil">
                <a href="/favoritos" class="">
                    <div class=" d-flex justify-content-between">
                        <div>
                            <i class="far fa-heart"></i>
                            <span class="ms-3">Favoritos</span>
                        </div>
                        <i class="fas fa-chevron-right"></i>
                    </div>
                </a>
            </div>
            <div class="enlace-perfil">
                <a href="/tutorial" class="">
                    <div class=" d-flex justify-content-between">
                        <div>
                            <i class="fas fa-question-circle"></i>
                            <span class="ms-3">Tutorial</span>
                        </div>
                        <i class="fas fa-chevron-right"></i>
                    </div>
                </a>
            </div>
            <div class="enlace-perfil">
                <div class=" d-flex justify-content-between">
                    <div class="color-red" @click="showModal = true;">
                        <i class="fas fa-trash"></i>
                        <span class="ms-3">Quiero darme de baja</span>
                    </div>
                    <i class="fas fa-chevron-right"></i>
                </div>
            </div>
            <div class="enlace-perfil">
                <a href="/logout" class="">
                    <div class=" d-flex justify-content-between">
                        <div>
                            <i class="fas fa-power-off"></i>
                            <span class="ms-3">Cerrar sesión</span>
                        </div>
                        <i class="fas fa-chevron-right"></i>
                    </div>
                </a>
            </div>
            <!--<div class="enlace-perfil">
                <a href="" class="">
                    <div class=" d-flex justify-content-between">
                        <div>
                            <i class="far fa-question-circle"></i>
                            <span class="ms-3">FAQ</span>
                        </div>
                        <i class="fas fa-chevron-right"></i>
                    </div>
                </a>
            </div>-->
        </div>
        <div id="modal" class="modal" v-if="showModal" :class="showModal ? 'd-block' : ''">
            <!-- Modal content -->
            <div class="modal-content text-center">
                <label class="descuento-label">¿Estás seguro que deseas darte de baja en TarifApp?</label>
                <button class="btn btn-secondary btn-block mt-3" @click="showModal = false">No, cancelar</button>
                <button class="btn btn-danger btn-block mt-3" @click="deleteAccount()">Si, darme de baja</button>
            </div>

        </div>
        <menu-component></menu-component>
    </div>
</template>

<script>

export default {
    data() {
        return {
            user: {},
            errors: null,
            showModal: false,
        };
    },
    methods: {
        deleteAccount() {
            this.$store
            .dispatch("deletePerfil")
            .then(response => {
                this.$router.push({name: "login"});
            })
            .catch(error => {
                this.errors = error.response.data;
            });
        }
    },
    mounted: function () {
        this.$store
        .dispatch("getPerfil")
        .then(response => {
            this.user = response.data;
        })
        .catch(error => {
            this.errors = error.response.data;
        });
    },
    computed: {
        // a computed getter
        full_name: function () {
            // `this` points to the vm instance
            if (this.user) {
                return this.user.nombre + ' ' + this.user.apellido
            }
        },
        empresaImage: function () {
            if (this.user) {
                if (this.user.logo) {
                    return 'background-image: url("/storage/' + this.user.logo + '")';
                } else {
                    return 'background-image: url("/assets/img/logo-empresa.jpg")';
                }

            }
        }
    }
}
;
</script>
